import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Globe2, Users, Briefcase, Award } from 'lucide-react';
const stats = [{
  label: 'Years Experience',
  value: '10+',
  icon: Award
}, {
  label: 'Projects Delivered',
  value: '100+',
  icon: Briefcase
}];
export function About() {
  return <section id="about" className="py-24 bg-slate-50 overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-sm font-semibold mb-6" data-id="element-13">
              <Globe2 className="w-4 h-4" data-id="element-14" />
              Global Presence
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6 leading-tight" data-id="element-15">
              Bridging Markets with <br className="hidden md:block" data-id="element-16" />
              <span className="text-accent" data-id="element-17">Dual-Continent</span> Expertise
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-18">
              With strategic presence in both the USA and Jordan,
              AlUniversalApps offers a unique competitive advantage. We combine
              Silicon Valley innovation standards with the exceptional tech
              talent of the MENA region, providing round-the-clock development
              cycles and cost-effective enterprise solutions.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-19">
              {stats.map((stat, index) => <div key={index} className="text-center sm:text-left" data-id="element-20">
                  <div className="flex items-center justify-center sm:justify-start gap-2 mb-2 text-accent" data-id="element-21">
                    <stat.icon className="w-5 h-5" data-id="element-22" />
                  </div>
                  <div className="text-2xl sm:text-3xl font-bold text-primary mb-1" data-id="element-23">
                    {stat.value}
                  </div>
                  <div className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-24">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Map/Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[500px] bg-white rounded-3xl shadow-xl border border-slate-100 p-8 flex flex-col justify-center" data-id="element-25">
            {/* Abstract Map Representation */}
            <div className="absolute inset-0 opacity-5" style={{
            backgroundImage: 'radial-gradient(#0F172A 2px, transparent 2px)',
            backgroundSize: '24px 24px'
          }} data-id="element-26"></div>

            <div className="relative z-10 space-y-8" data-id="element-27">
              {/* USA Office */}
              <div className="flex items-start gap-6 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-accent/30 transition-colors group" data-id="element-28">
                <div className="w-12 h-12 rounded-full bg-primary/5 flex items-center justify-center shrink-0 group-hover:bg-accent/10 transition-colors" data-id="element-29">
                  <MapPin className="w-6 h-6 text-primary group-hover:text-accent transition-colors" data-id="element-30" />
                </div>
                <div data-id="element-31">
                  <h3 className="text-xl font-bold text-primary mb-2" data-id="element-32">
                    Santa Clara, USA
                  </h3>
                  <p className="text-sm text-slate-600 mb-3" data-id="element-33">
                    Strategy & Engineering Hub
                  </p>
                  <div className="flex gap-2" data-id="element-34">
                    <span className="px-2 py-1 text-xs font-medium bg-white rounded-md border border-slate-200 text-slate-500" data-id="element-35">
                      PST Timezone
                    </span>
                    <span className="px-2 py-1 text-xs font-medium bg-white rounded-md border border-slate-200 text-slate-500" data-id="element-36">
                      Engineering
                    </span>
                  </div>
                </div>
              </div>

              {/* Connecting Line */}
              <div className="absolute left-[3.25rem] top-[6.5rem] bottom-[6.5rem] w-0.5 bg-gradient-to-b from-slate-200 via-accent/50 to-slate-200 hidden sm:block" data-id="element-37"></div>

              {/* Jordan Office */}
              <div className="flex items-start gap-6 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-accent/30 transition-colors group" data-id="element-38">
                <div className="w-12 h-12 rounded-full bg-primary/5 flex items-center justify-center shrink-0 group-hover:bg-accent/10 transition-colors" data-id="element-39">
                  <MapPin className="w-6 h-6 text-primary group-hover:text-accent transition-colors" data-id="element-40" />
                </div>
                <div data-id="element-41">
                  <h3 className="text-xl font-bold text-primary mb-2" data-id="element-42">
                    Amman, Jordan
                  </h3>
                  <p className="text-sm text-slate-600 mb-3" data-id="element-43">
                    Engineering & Delivery Center
                  </p>
                  <div className="flex gap-2" data-id="element-44">
                    <span className="px-2 py-1 text-xs font-medium bg-white rounded-md border border-slate-200 text-slate-500" data-id="element-45">
                      EET Timezone
                    </span>
                    <span className="px-2 py-1 text-xs font-medium bg-white rounded-md border border-slate-200 text-slate-500" data-id="element-46">
                      Core Engineering
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}